export default __webpack_public_path__ + "static/media/@paulbarroncas.1e8a72a0.PNG";